import type { TicketMeta, TicketStatus } from '@/types';

interface TicketCardProps {
  ticket: TicketMeta;
  status: TicketStatus;
  onClick?: () => void;
}

const STATUS_TO_DASH: Record<TicketStatus, string> = {
  'in-progress': 'progress',
  todo: 'todo',
  review: 'review',
  done: 'done',
  backlog: 'todo',
  locked: 'todo',
};

/** Dashboard active-tickets row — matches `.titem` styles. */
export function TicketCard({ ticket, status, onClick }: TicketCardProps) {
  const klass = STATUS_TO_DASH[status];
  const priCls = ticket.priority.toLowerCase();
  return (
    <button
      type="button"
      className={`titem ${klass}`}
      onClick={onClick}
      style={{
        background: 'var(--surface-2)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--r-md)',
        font: 'inherit',
        color: 'inherit',
        textAlign: 'left',
        cursor: 'pointer',
        width: '100%',
      }}
    >
      <div className="id">{ticket.id}</div>
      <div className="stat" />
      <div className="title">{ticket.title}</div>
      <div className={`pri ${priCls}`}>{ticket.priority}</div>
      <div className="ava">АК</div>
    </button>
  );
}
